import { useEffect, useState } from "react";
import { connect } from "react-redux";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTableForTop10";

import Cookies from "universal-cookie";

import { getTop10ReportHome } from "store";

const cookies = new Cookies();

const Top10MinMaxFailureReportsCardData = ({
  getTop10ReportHome,
  getTop10ReportHomeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  const [top10Data, setTop10Data] = useState([]);

  useEffect(() => {
    // getTop10ReportHome(jwtToken);
  }, []);
  useEffect(() => {
    let data = getTop10ReportHomeReducer.top10.data
      ? getTop10ReportHomeReducer.top10.data.groupedData.minMaxFailure
      : [];

    setTop10Data(data);
  }, [getTop10ReportHomeReducer]);

  const dataFromApi = {
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      { Header: "Description", accessor: "itemDescription" },
      { Header: "Type", accessor: "itemType" },
    ],

    rows: top10Data ? top10Data : [],
  };

  const { columns, rows } = dataFromApi;

  return (
    <Card>
      <MDBox mt={0}>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    getTop10ReportHomeReducer: state.getTop10ReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTop10ReportHome: (jwtToken) => dispatch(getTop10ReportHome(jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Top10MinMaxFailureReportsCardData);
